export default {
  accepted: 'Принято',
  accessRequestDate: 'Дата запроса доступа',
  confirmUserWillBeSystemAdmin: 'Пользователь станет системным администратором. Продолжить?',
  copyInvitationLink: 'Скопировать ссылку-приглашение в буфер обмена',
  copyInvitationLinkConfirmMessage: `Если приглашенный пользователь не получил никаких писем на адрес {{email}},
вы можете скопировать ссылку-приглашение в буфер обмена и поделиться ею с ним другими способами.

Скопировать ссылку-приглашение в буфер обмена?`,
  copyPasswordResetLink: 'Скопировать ссылку для сброса пароля в буфер обмена?',
  copyPasswordResetLinkConfirmMessage: `Если пользователь сбросил свой пароль, но не получил никаких писем на адрес {{email}},
вы можете скопировать ссылку для сброса пароля в буфер обмена и поделиться ею с ним другими способами.

Скопировать ссылку для сброса пароля в буфер обмена?`,
  editSurveyUserExtraPropsForUser:
    'Редактировать дополнительные свойства пользователя опроса для пользователя "{{userName}}"',
  inviteUser: 'Пригласить',
  invitationExpiredClickToSendAgainTheInvitation: 'Приглашение истекло: нажмите, чтобы отправить приглашение снова',
  invitationLinkCopiedToClipboard: 'Ссылка-приглашение скопирована в буфер обмена',
  invitedBy: 'Приглашен(а) кем',
  invitedDate: 'Дата приглашения',
  lastLogin: 'Последний вход',
  moreThan30DaysAgo: 'Более 30 дней назад',
  notAcceptedYet: 'Приглашение еще не принято',
  passwordResetLinkCopiedToClipboard: 'Ссылка для сброса пароля скопирована в буфер обмена',
  passwordResetLink: 'Ссылка для сброса пароля',
  prefs: {
    title: 'Настройки уведомлений',
    notifyOnUserAccessRequest: 'Новые запросы на доступ',
  },
  roleInCurrentSurvey: 'Роль в текущем опросе',
  roleInSurvey: 'Роль в опросе',
  filterPlaceholder: 'Фильтровать по имени или email',
  surveyName: 'Название опроса',
  surveyExtraProp: {
    label: 'Дополнительное свойство опроса',
    label_other: 'Дополнительные свойства опроса',
  },
  surveysDraft: 'Опросы (черновик)',
  surveysPublished: 'Опросы (опубликовано)',
  userRemovedFromSurveyGoToSurveysRequired: `Вы были удалены из этого опроса.  
Нажмите «Перейти к опросам», чтобы открыть список опросов.`,
  userRoleUpdatedRefreshRequired: `Ваша роль в этом опросе была обновлена.  
$t(common.pressRefreshToReloadPage)`,
  userGroup: {
    new: 'Новая группа',
    edit: 'Редактировать группу',
    name: 'Название',
    label: 'Метка',
    qualifier: 'Квалификатор {{index}}',
    qualifier_plural: 'Квалификаторы',
    qualifierKey: 'Ключ',
    qualifierValue: 'Значение',
    addQualifier: 'Добавить квалификатор',
    members: 'Участники',
    addMember: 'Добавить участника',
    noMembers: 'Пока нет участников',
    memberAlreadyInGroup: 'В настоящее время в "{{groupName}}"',
    tabs: {
      groups: 'Группы пользователей',
      assignments: 'Распределение по группам',
      report: 'Отчёт по участникам',
    },
    memberName: 'Имя участника',
    memberEmail: 'Email участника',
    memberRole: 'Роль в опросе',
    memberStatus: 'Статус',
    status: {
      INVITED: 'Приглашен',
      ACCEPTED: 'Принято',
      FORCE_CHANGE_PASSWORD: 'Требуется смена пароля',
    },
    unassigned: 'Не назначено',
    confirmDelete: 'Удалить группу "{{name}}"? Ее участники станут неназначенными. Продолжить?',
    deleteConfirmed: 'Группа "{{name}}" была удалена',
    saveConfirmed: 'Группа "{{name}}" была сохранена',
    confirmReassign: '{{userName}} в настоящее время находится в группе "{{groupName}}". Переместить его в эту группу?',
    notFound: 'Группа не найдена',
  },
  updateUserConfirmation: 'Пользователь {{name}} обновлен',
  userNotInvitedToAnySurvey: `Пользователь не приглашен ни в один опрос`,
  userSurveys: 'Опросы пользователя',
}
